import { useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PHRASES = [
  { text: "I've been holding", accent: 'everything together.' },
  { text: "I've been everyone's", accent: 'everything.' },
  { text: 'And somewhere along the way…', accent: 'I lost myself.' },
];

const EmotionalOpening = () => {
  const root = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const phrases = gsap.utils.toArray('.eo-phrase');
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          end: '+=280%',
          pin: true,
          scrub: 1.4,
        },
      });
      phrases.forEach((el, i) => {
        tl.fromTo(el, { opacity: 0, y: 60, filter: 'blur(10px)' }, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 2.2, ease: 'power2.out' }, i * 4.2);
        if (i < phrases.length - 1) {
          tl.to(el, { opacity: 0, y: -50, filter: 'blur(8px)', duration: 1.8, ease: 'power2.in' }, i * 4.2 + 2.8);
        }
      });
      tl.to('.eo-img', { yPercent: -14, ease: 'none', duration: phrases.length * 4.2 }, 0);
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} data-testid="emotional-opening-section" className="relative h-[100svh] overflow-hidden bg-[#F5F0E8]">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="eo-img w-[46vw] max-w-md aspect-[3/4] opacity-[0.09] will-change-transform">
          <img
            src="https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=900&q=60"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="relative h-full flex items-center justify-center px-6">
        {PHRASES.map((p, i) => (
          <div key={i} className="eo-phrase absolute text-center max-w-5xl px-6" style={{ opacity: 0 }}>
            <p className="font-serif-display font-light text-4xl sm:text-6xl lg:text-7xl leading-[1.15] text-[#2C2C2A]">
              {p.text}
              <br />
              <em className="text-[#1A4D38]">{p.accent}</em>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EmotionalOpening;
